import { ReactElement } from 'react'
import { Helmet } from 'react-helmet'
import { getIsMobile } from '../../redux/reducers/appSettings'
import { useAppSelector } from '../../redux/hooks'
import { StyledHeader } from './styles'
import {
    Container,
    Flex,
    Grid,
    Image,
    Link,
    Stars,
    Text,
} from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import ReactCountryFlag from 'react-country-flag'
import { PropsHeaderTemplate } from './props'

const HeaderTemplate = ({
    languages,
    numberOfReviews,
}: PropsHeaderTemplate): ReactElement => {
    const { t, i18n } = useTranslation()

    const isMobile = useAppSelector((state) => getIsMobile(state))

    const logoLink = 'https://raskrask.dk'
    const logoSrc =
        'https://www.raskrask.dk/wp-content/uploads/2019/11/logo-700-1.png.webp'
    const trustPilotLink = 'https://dk.trustpilot.com/review/raskrask.dk'

    return (
        <StyledHeader>
            <Helmet>
                <html lang={i18n.language} />
            </Helmet>
            <Container>
                <Flex>
                    <Link href={logoLink} target="_blank">
                        <Image src={logoSrc} />
                    </Link>
                    <Flex gap={16}>
                        <Grid
                            gap={isMobile ? 4 : 8}
                            autoFlow={isMobile ? 'row' : 'column'}
                            css={{ alignItems: 'center' }}
                        >
                            {!isMobile && (
                                <Text
                                    size={{
                                        '@mobile': 's',
                                        '@desktop': 'm',
                                    }}
                                >
                                    {t('common:excellent')}
                                </Text>
                            )}
                            <Stars rating={5} size="l" />
                            <Link href={trustPilotLink} target="_blank">
                                {t('common:reviewsWithCount', {
                                    count: numberOfReviews,
                                })}
                            </Link>
                        </Grid>
                        {Object.keys(languages).map((lng, key) => {
                            return (
                                i18n.resolvedLanguage !== lng && (
                                    <ReactCountryFlag
                                        countryCode={lng.slice(-2)}
                                        key={key}
                                        onClick={() =>
                                            i18n.changeLanguage(
                                                Object.keys(languages).filter(
                                                    (val) => val === lng
                                                )[0]
                                            )
                                        }
                                        svg
                                        style={{
                                            cursor: 'pointer',
                                            width: '1.5rem',
                                            height: '1.5rem',
                                        }}
                                    />
                                )
                            )
                        })}
                    </Flex>
                </Flex>
            </Container>
        </StyledHeader>
    )
}

export default HeaderTemplate
